<template>
  <v-text-field
      v-bind="$attrs"
      :value="value"
      dense
      outlined
      :clearable="clearable"
      @input="$emit('input', $event !== '' ? $event : null)"
      append-icon="mdi-web"
      @click:append="onAppendClick(value)"
  >
  </v-text-field>
</template>

<script>

export default {
  name: 'CommonFieldLink',
  inheritAttrs: false,
  props: {
    value: {default: null},
    clearable: {default: false},
  },

  components: {},

  computed: {
  },

  methods: {
    onAppendClick(link) {
      if (!!link)
        window.open(link, '_blank')
    }
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
